<template>
    <div class="loginPage" :style="backgroundStyle">
        <div style="flex: 1 1 0%;display: flex;align-items: center;">
            <!-- <div class="topColor">
                <div class="imgBox">
                    <img :src="logoImg" alt="">
                </div>
            </div> -->
            <div class="loginMiddle">
                <div class="middleFlexBox setContWidth">
                    <!--<img :src="middleImg" class="themeImg" alt="">-->
                    <div class="loginBox">
                        <div class="loginTitle" v-show="loginType === 'code' || loginType === 'pwd'">
                            <span :class="loginType === 'code' ? 'active' : ''" @click="changeLoginType('验证码登录', 'code')">验证码登录</span>
                            <em class="line"></em>
                            <span :class="loginType === 'pwd' ? 'active' : ''" @click="changeLoginType('密码登录', 'pwd')">密码登录</span>
                        </div>
                        <div class="loginTitle" v-show="loginType !== 'code' && loginType !== 'pwd'">
                            <span class="active">{{title}}</span>
                        </div>
                        <LoginBox @changeLoginType="changeLoginType(...arguments)" :loginType="loginType" :link="redirect_url" v-if="loginType === 'code' || loginType === 'pwd'" />
                        <FindPassword v-else-if="loginType === 'findPwd'" @changeLoginType="changeLoginType(...arguments)" />
                        <ChangePassword v-else-if="loginType === 'changePwd'" @changeLoginType="changeLoginType(...arguments)" />
                        <Register v-else-if="loginType === 'register'" @changeLoginType="changeLoginType(...arguments)" />
                        <RegisterPwd v-else-if="loginType === 'registerPwd'" @changeLoginType="changeLoginType(...arguments)" />
                        <!-- <div class="bottomTip">
                            <span v-if="loginType === 'code' || loginType === 'pwd'" @click="changeLoginType('注册账号', 'register')">没有账号？立即注册</span>
                            <span v-else @click="changeLoginType('密码登录', 'code')">已有账号？立即登录</span>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- <Bottom /> -->
    </div>
</template>
<script lang="js">
import middleImg from '../../assets/loginMiddle.png'
import logoImg from '../../assets/logo.png'
import LoginBox from './components/login'
import ChangePassword from './components/changePassword'
import FindPassword from './components/findPassword'
import Register from './components/register'
import RegisterPwd from './components/registerPwd'
import Bottom from '@/views/Bottom'
export default {
    components: {
        LoginBox,
        ChangePassword,
        FindPassword,
        Register,
        RegisterPwd,
        Bottom
    },
    data () {
        return {
            middleImg: middleImg,
            logoImg: logoImg,
            loginType: '',
            title: ''
        }
    },
    mounted () {
        this.getStoreLoginType()
    },
    methods: {
        changeLoginType (text, type) {
            this.title = text
            this.loginType = type
        },
        getStoreLoginType () {
            if (this.redirect_loginType === 'pwd' || this.redirect_loginType === '' || !this.redirect_loginType) {
                this.changeLoginType('密码登录', 'pwd')
            } else if (this.redirect_loginType === 'register') {
                this.changeLoginType('注册账号', 'register')
            } else if (this.redirect_loginType === 'findPwd') {
                this.changeLoginType('找回密码', 'findPwd')
            }
        }
    },
    computed: {
        redirect_loginType () {
            return window.localStorage.getItem('redirect_loginType')
        },
        redirect_url () {
            return window.localStorage.getItem('redirect_url')
        },
        backgroundStyle() {
            return `background-image: url("${this.middleImg}");`
        }
    },
    beforeDestroy() {
        window.localStorage.removeItem('redirect_loginType')
        window.localStorage.removeItem('redirect_url')
    }
}
</script>
<style lang="scss" scoped>
.loginPage {
    width: 100%;
    background-size: cover;
    //height: calc( 100vh - 36px );
    height: 100%;
    // min-height: 730px;
    flex-direction: column;
    display: flex;

    .topColor {
        display: flex;
        justify-content: center;
        width: 100vw;
        height: 80px;
        background: rgba(255, 255, 255, 0.2);

        .imgBox {
            display: flex;
            align-items: center;
            width: 100%;
            padding-left: 15px;

            img {
                width: 110px;
                //height: 86px; 限制高度会变形
            }
        }
    }

    .loginMiddle {
        width: 100%;
        //padding-top: calc(50vh - 304px);
        //background: #EBF6FF;

        .middleFlexBox {
            display: flex;
            justify-content: center;

            //.themeImg {
            //    position: relative;
            //    top: 11px;
            //    width: 779px;
            //    height: 420px;
            //    margin-right: -11px;
            //}

            .loginBox {
                width: 360px;
                height: 388px;
                padding: 30px 30px 24px;
                background: #fff;
                border-radius: 8px;
                box-shadow: 0px 6px 10px 0px #E5F2FD;
                z-index: 1;

                .loginTitle {
                    height: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    span {
                        font-size: 20px;
                        font-weight: 400;
                        line-height: 20px;
                        color: #999999;
                        cursor: pointer;
                    }

                    span.active, span:hover {
                        color: #0263BB;
                    }

                    em {
                        display: block;
                        width: 1px;
                        height: 20px;
                        margin: 0 41px 0 44px;
                        background: #E6E6E6;
                    }
                }

                .bottomTip {
                    padding-top: 44px;
                    text-align: center;
                    span {
                        font-size: 14px;
                        line-height: 20px;
                        color: #999999;
                        cursor: pointer;
                    }

                    span:hover {
                        color: #0263BB;
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss">
.loginPage {
    .loginContent {

        .el-input__inner {
            height: 46px;
            padding:0 98px 0 38px;
            border-color: #ccc;
            color: #333333;
        }

        .el-input__inner:hover, .el-input__inner:focus {
            border-color: #0263BB;
        }

        .el-input__inner::-webkit-input-placeholder {
            color: #999999;
        }

        .el-input__inner:-moz-placeholder {
            color: #999999;
        }

        .el-input__inner:-ms-input-placeholder {
            color: #999999;
        }

        .el-input__inner::placeholder {
            color: #999999;
        }

        .el-button--primary.is-disabled, .el-button--primary.is-disabled:hover, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:active {
            opacity: .5;
            background-color: #0263BB;
            border-color: #0263BB;
        }
    }
}
::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background: #3a3f4e;
}
</style>
